const endpoints = {
  login: '/auth/ajaxLogin',
  logout: '/auth/logout',
  isloggedin: '/auth/isloggedin',
};
export default endpoints;
